import * as React from "react";
import { Card, CardContent, CardMedia, Typography, CardActionArea } from "@material-ui/core";
import CheckCircleRoundedIcon from "@material-ui/icons/CheckCircleRounded";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import translate from "../../../../i18n/translate";

const CourseCard = ({ cardImage, cardTitle, duration, level, showStatus, toGlobalCommunityTutorials, nodeId, course }: any) => {
  const getImageName = () => {
    if (cardImage && cardImage.length > 0) {
      const imageName = cardImage.split("/").pop();
      return `${process.env.REACT_APP_BLOB_STORAGE}/gctassets/${imageName}`;
    } else {
      return "";
    }
  };

  const getLevelBar = (level: number) => {
    const enableOne = level === 1 || level === 2 || level === 3;
    const enableTwo = level === 2 || level === 3;
    const enableThree = level === 3;
    return (
      <div className="level-bar">
        <div className={`bar-one ${enableOne ? "addBg" : ""}`}></div>
        <div className={`bar-two ${enableTwo ? "addBg" : ""}`}></div>
        <div className={`bar-three ${enableThree ? "addBg" : ""}`}></div>
      </div>
    );
  };

  return (
    <Card className="course-card-component" onClick={() => {
      toGlobalCommunityTutorials(nodeId,course)
    }}>
      {showStatus && (
        <div className="set-status-icon-box">
          <CheckCircleRoundedIcon className="status-icon" />
        </div>
      )}
      <CardActionArea className="course-card-action-area">
        <CardMedia component="img" className="course-card-image" image={getImageName()} alt={cardTitle} />
        <CardContent className="course-card-contents">
          <Typography variant="h5" className="course-card-title">
            {cardTitle}
          </Typography>
          <div className="course-card-details">
            <p className="duration-tag">
              <AccessTimeIcon className="duration-icon" />
              <span className="duration-label">
                {duration} {translate("sessionRating_sessionDetails_mins")}
              </span>
            </p>
            {getLevelBar(Number(level))}
          </div>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default CourseCard;
